module.exports = __webpack_public_path__ + "static/media/Koobot_Processed_03B.452c0683.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/Koobot_Processed_03B.mp3
// module id = 105
// module chunks = 0